import {
  Context,
  useUserFactory,
  UseUserFactoryParams
} from '@vue-storefront/core';
import type { User } from '@bee-hole/api';
import { useCart } from '../useCart';
import { useWishlist } from '../useWishlist';
import { useApiError } from '../useApiError';
import type {
  UseUserUpdateParams as UpdateParams,
  UseUserRegisterParams as RegisterParams
} from '../types';

const params: UseUserFactoryParams<User, UpdateParams, RegisterParams> = {
  provide: () => ({
    useCart: useCart(),
    useWishlist: useWishlist(),
    useApiError: useApiError()
  }),

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  load: async (context: Context) => {
    const res = await context.$xbuy.api.customProfile();
    if (res.code === 0) {
      // await context.useWishlist.load(context);
      await context.useCart.setCart(null);
      // await context.useCart.load(context);
      return res.data;
    }
    // throw new Error('未登录');
    return res.data;
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  logOut: async (context: Context) => {
    await context.useCart.setCart(null);

    await context.$xbuy.api.customLogout();
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  updateUser: async (context: Context, { currentUser, updatedUserData }) => {
    // console.log('updatedUserData', updatedUserData, currentUser);
    const res = await context.$xbuy.api.constomUpUser(updatedUserData);
    const data = await params.load(context);
    if (res.code > 0) {
      context.useApiError.set(res);
    } else {
      context.useApiError.set({ message: 'Api_Update_success', code: 0 });
    }
    return data;
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  register: async (context: Context, { email, password, firstName, lastName, phone, code, phone_country_code }) => {
    const res = await context.$xbuy.api.customRegister({ email, password, firstName, lastName, phone, code, phone_country_code });
    if (res && res.data && res.data.member_id) {
      // 自动登录
      if (email) {
        const data = await params.logIn(context, { username: email, password, customQuery: { phone: undefined, phone_country_code: undefined } });
        return data;
      } else if (phone) {
        const data = await params.logIn(context, { username: undefined, password, customQuery: { phone, phone_country_code } });
        return data;
      }
    } else {
      throw new Error(res.message);
    }
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  logIn: async (context: Context, { username, password, customQuery }) => {
    const { phone, phone_country_code } = customQuery;
    const res = await context.$xbuy.api.customLogin({ username, password, phone, phone_country_code });
    if (res && res.code && res.code > 0) {
      context.useApiError.set(res);
      throw new Error(res.message);
    }
    const data = await params.load(context);
    return data;
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  changePassword: async (context: Context, { currentUser, currentPassword, newPassword }) => {
    const res = await context.$xbuy.api.customPass({ current_pwd: currentPassword, password_1: newPassword, password_2: newPassword });
    if (res && res.code && res.code > 0) {
      context.useApiError.set(res);
      throw new Error(res.message);
    }
    const data = await params.load(context);
    return data;
  }
};

export const useUser = useUserFactory<User, UpdateParams, RegisterParams>(params);
